module.exports = __webpack_public_path__ + "img/asset-delete.8b6b6c52.png";